import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Menu } from "@mui/material";
import _ from "lodash";
import React, { useRef, useState } from "react";
import { Button } from "../Button/Button";
import { MenuItemCheckbox } from "./MenuItemCheckbox";
export function FilterMenu(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const muiButtonRef = useRef(null);
    const { id: passedInId, className, style, items, onSelectedChanged, menuAnchorOrigin, menuTransformOrigin, container, endIcon: passedInEndIcon, ...buttonProps } = props;
    const id = passedInId ?? _.uniqueId("filtermenu-");
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setExpanded(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setExpanded(false);
    };
    const onItemClicked = (item, newIsChecked) => {
        const changedItem = { ...item, checked: newIsChecked };
        if (onSelectedChanged) {
            onSelectedChanged(changedItem);
        }
    };
    const buttonWidth = muiButtonRef.current?.getBoundingClientRect().width;
    const renderedItems = items.map((item) => {
        return (React.createElement(MenuItemCheckbox, { key: item.displayName, checked: item.checked ?? false, setChecked: (checked) => onItemClicked(item, checked), handleClose: handleClose, style: buttonProps.iconButton ? undefined : { minWidth: buttonWidth, paddingLeft: "0.25em" } }, item.displayName));
    });
    const expandIcon = expanded ? React.createElement(ExpandLessIcon, { fontSize: buttonProps.size }) : React.createElement(ExpandMoreIcon, { fontSize: buttonProps.size });
    const endIcon = passedInEndIcon ?? expandIcon;
    const buttonId = `${id}-filterbutton`;
    const menuId = `${id}-filtermenu`;
    const isOpen = Boolean(anchorEl);
    const containerHeight = container?.getBoundingClientRect().height;
    return (React.createElement("div", { id: id, className: className, style: style },
        React.createElement(Button, { id: buttonId, "aria-hidden": false, "aria-controls": menuId, "aria-haspopup": true, "aria-expanded": isOpen, endIcon: endIcon, onClick: handleClick, muiButtonRef: muiButtonRef, showActiveState: isOpen, ...buttonProps }),
        React.createElement(Menu, { MenuListProps: { id: menuId, "aria-labelledby": buttonId }, anchorEl: anchorEl, keepMounted: true, open: isOpen, onClose: handleClose, anchorOrigin: menuAnchorOrigin, transformOrigin: menuTransformOrigin, sx: { paper: { boxShadow: `0px 5px 5px -3px rgba(0,0,0,0.1),0px 8px 10px 1px rgba(0,0,0,0.08),0px 3px 14px 2px rgba(0,0,0,0.06)` } }, style: { maxHeight: containerHeight } }, renderedItems)));
}
//Prop defaults.
FilterMenu.defaultProps = {
    disabled: false,
    rounded: false,
    variant: "contained",
    color: "primary",
    text: "",
    size: "small",
    menuAnchorOrigin: { vertical: "bottom", horizontal: "left" },
    menuTransformOrigin: { vertical: "top", horizontal: "left" },
    container: null
};
